<template id="child">

  <div v-if="showModal" :style="cssProps">
      <div>
    <div class="modal d-flex flex-column">
      <h1>Add Gift</h1>
        <!-- begin -->
       <div class="bg-credit d-flex justify-content-center align-items-center">
          <i class="fal fa-gift-card"></i>
       </div>
       <div class="col-input d-flex flex-column justify-content-around align-items-center">
       <input type="text" placeholder="Enter Gift Card Code">
       <input type="password" name="pin" maxlength="4" placeholder="PIN">
       </div>
              <span>If entering a gift card code, your gift card amount will be transferred to your online credit and you will no longer be able to use your physical gift card.</span>

      <!-- end -->
      <div class="d-flex flex-row justify-content-around btn-cancel" @click="hide">
      <button >
        <span>Cancel</span>
      </button>
       <button >
        <span>Apply</span>
      </button>
      </div>
    </div>
    </div>
    
      
    <div class="modal-overlay"></div>
  </div>
  
</template>
<script>

import { mapState } from "vuex";
export default {
  template: "#child",
  data() {
    return {
      showModal: false,
    
    };
  },
  computed: {
    ...mapState(['info']),
		cssProps() { return {
        '--main-color': this.info.color ? "#" + this.info.color : "#c12d39"
      }
    }
	},
  methods: {
     
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
      
    },
   
  },
  created(){
  }
};
</script>
<style scoped>
.col-input{
    padding-top: 24px;
}
span{
   
	opacity: 0.3;
	color: #000000;
	font-family: Poppins;
	font-size: 11px;
	font-weight: 500;
	line-height: 18px;
}

.col-input input:first-child{

	height: 56px;
	width: 336px;
	background-color: #FFFFFF;
	box-shadow: 0 1px 0 0 rgba(0,0,0,0.2);
    margin-bottom: 5px;

}
.col-input input:last-child{

	height: 56px;
	width: 35px;
	background-color: #FFFFFF;
	box-shadow: 0 1px 0 0 rgba(0,0,0,0.2);
    text-align: center
}
.bg-credit
{

	height: 192px;
	width: 336px;
	border-radius: 16px;
	background-color: rgba(0,0,0,0.1);
}
.bg-credit i {
   

	opacity: 0.8;
	color: #000000;
	font-family: "Font Awesome 5 Pro";
	font-size: 64px;
	font-weight: 300;
	line-height: 64px;
}


.btn-row button{

	height: 112px;
	width: 158px;
	border: 1px solid rgba(0,0,0,0.1);
	border-radius: 16px;
	background-color: rgba(0,0,0,0.1);
}
.btn-row button i {
   
	
	opacity: 0.8;
	color: #000000;
	font-family: "Font Awesome 5 Pro";
	font-size: 64px;
	font-weight: 300;
	line-height: 64px;

}
.btn-row button span{
  
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: bold;
	line-height: 20px;

}

.active {
    background-color: rgba(0,0,0,0.6) !important;
    opacity: 1 !important;
    color: #ffffff;
}
.active span:first-child{

	color: #FFFFFF;
	font-family: Poppins;
	font-size: 20px;
	font-weight: bold;
	line-height: 30px;
    opacity: 1;
	
}
.active span:first-child::after{
    opacity: 1!important;
    color:#FFFFFF!important;
}
.active span:nth-child(2){
   
	color: #FFFFFF !important;
	font-family: Poppins !important;
	font-size: 12px !important;
	font-weight: 500 !important;
	line-height: 18px !important;
    opacity: 1 !important;

}



button{
  border: none;
  outline: none;
  background: none;
}
.btn-cancel button
{
 margin-top: 40px;
	height: 48px;
	width: 160px;
	border: 1px solid var(--main-color);
	border-radius: 24px;
	background-color: #FFFFFF;
}
.btn-cancel button:last-child{
    background-color: rgba(0,0,0,0.6);
    border:none;
}
.btn-cancel button:last-child span{
    color:#FFFFFF;
}
.btn-cancel span{
 
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	text-align: center;
}


.modal {
   position: fixed;;
  left:30%;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  overflow-y:auto;
  padding: 48px;
  box-sizing: border-box;

  z-index: 6;

  height: 617px;
 width: 434px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #ffffff;
}
.modal h1 {
 
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 24px;
	font-weight: 800;
	line-height: 35px;
	text-align: center;

}

.modal-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 5;
}
input
{
     border: none;
  padding: 0;
  background: none;
  outline: none;
}
input::placeholder{
    
	opacity: 0.3;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	/* line-height: 20px; */
}


/* .active {
  background-color: var(--main-color) !important;
}
.active i {
  color: #ffffff !important;
}
.active span {
  color: #ffffff !important;
} */
@media screen and (max-width: 600px)
{
  .modal{
    width: 100%;
    height: 80%;
      padding:40px;
      left:0;
  }
  .column-input
  {
    height: 80%;
  }
  .column-input input
  {
    width: 100%;
  }
  .button
    {
        flex-direction: column-reverse !important;
        justify-content: center !important;
        align-items: center !important;

    }
    .button button:first-child
    {
        width: 100%;
        margin-top: 10px;
    }
    .button button:last-child
    {
        width: 100%;
    }
  
}
</style>



// WEBPACK FOOTER //
// src/components/steps/modals/redemGift.vue